import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { formFooterHeight, headerHeight } from '~/utilities';

export const FormStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 100%;
  height: calc(100vh - ${formFooterHeight + headerHeight}px);
  overflow-y: auto;
`;

export const FormContainerStyled = styled(Box).attrs({
  ml: { sm: '450' },
  mt: { sm: '450' },
  py: { sm: '550' },
  pl: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-radius: ${theme.spacings[200]} 0 0 ${theme.spacings[200]};
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  `}
`;

export const ContentStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 655px;
`;

export const SectionHeaderStyled = styled(Box).attrs({
  pb: { sm: '400' },
  mb: { sm: '500' },
})`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[800]};
`;

export const ListSelectionStyled = styled(Box).attrs({
  mb: { sm: '450' },
  alignItems: { sm: 'center' },
})`
  cursor: pointer;
  width: fit-content;
`;
